import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';

import { clientAssessmentActions } from '../../../../../store';

import type { Moment } from 'moment';

function useBackdateAssessment(assessmentId: number | undefined) {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const [showConfirmBackdateDialog, setShowConfirmBackdateDialog] = useState(false);
  const [pendingBackdateDate, setPendingBackdateDate] = useState<Moment | null>(null);
  const [pendingBackdateUtcOffset, setPendingBackdateUtcOffset] = useState<number | null>(null);

  const requestBackdate = useCallback((backdatedDate: Moment, utcOffset: number | null) => {
    setPendingBackdateDate(backdatedDate);
    setPendingBackdateUtcOffset(utcOffset);
    setShowConfirmBackdateDialog(true);
  }, []);

  const handleBackdateAssessment = useCallback(async () => {
    if (!assessmentId || !pendingBackdateDate) return;
    setShowConfirmBackdateDialog(false);

    const { error } = await dispatch(
      clientAssessmentActions.backdateAssessmentNote({
        assessmentNoteId: assessmentId,
        data: {
          date_start: pendingBackdateDate,
          utc_offset_date_start: pendingBackdateUtcOffset ?? 0,
        },
        getAccessTokenSilently,
      }),
    );

    if (error) return;

    dispatch(
      clientAssessmentActions.getAssessmentNote({
        assessmentNoteId: assessmentId,
        getAccessTokenSilently,
      }),
    );
  }, [dispatch, getAccessTokenSilently, assessmentId, pendingBackdateDate, pendingBackdateUtcOffset]);

  return {
    showConfirmBackdateDialog,
    setShowConfirmBackdateDialog,
    requestBackdate,
    handleBackdateAssessment,
  };
}

export default useBackdateAssessment;
